import getApiClient from '@/plugins/api-client'

export default {
    loadData: function () {
        const self = this,
            api = getApiClient(self.$store),
            parameters = self.filters

        api.get('/best_rated_profiles', {
            params: {
                page: self.currentPage,
                itemsPerPage: self.itemsPerPage,
                ...parameters
            }
        })
            .then(result => {
                self.totalPages = Math.ceil(result.data['hydra:totalItems'] / self.itemsPerPage)
                self.profiles = result.data['hydra:member']
            })
            .catch(error => {
                console.log(error)
            })
    },

    setCategory(category) {
        this.filters.category = category.code
    },

    clearFilters() {
        this.filters.category = null

        this.loadData()
    },

    updatePage: function (page) {
        this.currentPage = page
    }
}
